export default __webpack_public_path__ + "static/media/add-property.png?.7650c178";